import { DealershipFilter, SiteSearchFiltersInput } from '@domain/graphql.types';

/** Query string of GET /sites: only the restrictive filters are sent, so no filter means the unfiltered request. */
export const toSitesQueryString = (filters?: SiteSearchFiltersInput | null): string => {
  const params = new URLSearchParams();

  for (const networkId of filters?.networkIds ?? []) {
    params.append('networks', networkId);
  }
  if (filters?.minimumPortsPerStation != null) params.set('minPorts', String(filters.minimumPortsPerStation));
  if (filters?.minimumPowerKwPerPort != null) params.set('minPowerKw', String(filters.minimumPowerKwPerPort));
  if (filters?.openedFrom) params.set('openedFrom', filters.openedFrom);
  if (filters?.openedTo) params.set('openedTo', filters.openedTo);
  if (filters?.dealership && filters.dealership !== DealershipFilter.All) params.set('dealership', filters.dealership.toLowerCase());

  return params.toString();
};

const SitesRequest = (token: string, filters?: SiteSearchFiltersInput | null): Request => {
  const url = new URL('sites', import.meta.env.VITE_BACKEND_URL);
  url.search = toSitesQueryString(filters);

  return new Request(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export default SitesRequest;
